//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** Specifies the format of notes that belong to the NoteType. */
export const NoteFormatType = {
    /** The format of the notes is unknown, but assumed to be structured. */
    Unknown: 0,

    /**
     * The format of the notes is unstructured data and not compatible
     * with some of the more advanced features of notes.
     */
    Unstructured: 1,

    /**
     * The format of the notes is a structured format. Only Rock components
     * should set the note text value.
     */
    Structured: 2
} as const;

/** Specifies the format of notes that belong to the NoteType. */
export const NoteFormatTypeDescription: Record<number, string> = {
    0: "Unknown",

    1: "Unstructured",

    2: "Structured"
};

/** Specifies the format of notes that belong to the NoteType. */
export type NoteFormatType = typeof NoteFormatType[keyof typeof NoteFormatType];
